export function localYmd(d: Date): string {
	const y = d.getFullYear()
	const m = String(d.getMonth() + 1).padStart(2, '0')
	const day = String(d.getDate()).padStart(2, '0')
	return `${y}-${m}-${day}`
}

export function normalizeRange(from: string, to: string): { from: string; to: string } {
	let a = from
	let b = to
	if (!a && b) a = b
	if (!b && a) b = a
	if (a && b && a > b) {
		return { from: b, to: a }
	}
	return { from: a, to: b }
}

/** Начало календарного дня YYYY-MM-DD в локальном времени */
export function startOfYmdMs(ymd: string): number | null {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null
	const [y, m, d] = ymd.split('-').map(Number)
	const dt = new Date(y, m - 1, d, 0, 0, 0, 0)
	if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null
	return dt.getTime()
}

/** Конец календарного дня YYYY-MM-DD в локальном времени */
export function endOfYmdMs(ymd: string): number | null {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null
	const [y, m, d] = ymd.split('-').map(Number)
	const dt = new Date(y, m - 1, d, 23, 59, 59, 999)
	if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return null
	return dt.getTime()
}
